/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { z } from 'zod';
import { type ContactEntity, contactSchema } from '@axiom/domain';
import { calendarDtoSchema } from './calendar-dto';

export const interviewContactDtoSchema = contactSchema.pick({ "email": true, "id": true }).extend({ "calendar": z.lazy(() => calendarDtoSchema).nullish(), "fullName": z.string().nullish() });
export type InterviewContactDto = Pick<ContactEntity, "email" | "id"> & z.infer<typeof interviewContactDtoSchema>;
